// Marca «Reseña en Google» en la ficha del cliente (1-oct-2026): si ya se le pidió (una vez
// para siempre) y si abrió el enlace. Sin solicitud no pinta nada. Datos: /google-reviews/contact/:id.
import React, { useEffect, useState } from 'react';
import { Star } from 'lucide-react';
import { googleReviewsApi, type GRAsk } from '../../../api/googleReviewsApi';

const fecha = (s: string) => s.slice(0, 10).split('-').reverse().join('/');

const GoogleReviewChip: React.FC<{ clientId: string }> = ({ clientId }) => {
  const [ask, setAsk] = useState<GRAsk | null>(null);
  useEffect(() => {
    let vivo = true;
    googleReviewsApi.contact(clientId).then((r) => { if (vivo) setAsk(r.ask); }).catch(() => {});
    return () => { vivo = false; };
  }, [clientId]);
  if (!ask) return null;
  const fue = !!ask.clickedAt;
  const texto = ask.status === 'shadow'
    ? 'Reseña Google: le tocaría (en prueba)'
    : fue ? `Fue a Google el ${fecha(ask.clickedAt as string)}` : `Reseña Google pedida el ${fecha(ask.at)}`;
  return (
    <span
      title="Se le pide una sola vez. No se le volverá a pedir."
      className={`inline-flex items-center px-2 py-0.5 text-xs font-medium rounded-full border ${fue
        ? 'bg-emerald-50 dark:bg-emerald-500/10 text-emerald-700 dark:text-emerald-300 border-emerald-200 dark:border-emerald-500/30'
        : 'bg-amber-50 dark:bg-amber-500/10 text-amber-700 dark:text-amber-300 border-amber-200 dark:border-amber-500/30'}`}
    >
      <Star className="h-3 w-3 mr-1" />{texto}
    </span>
  );
};

export default GoogleReviewChip;
